import { createFileRoute } from '@tanstack/react-router'
import { AlertRuleFormPage } from '../../../features/alerts/AlertRuleFormPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/alerts/new')({
  component: () => <AlertRuleFormPage />,
})
